<template>
  <div class="mainBody">
    <enterTit title="销售网点"></enterTit>
    <div class="xswd">
      <!-- <div class="xswd_p">
        以广东为中心、辐射全国。即：以广东为中心、向广东周边如海南、广西、福建、湖南等辐射、面向全国(重点是以京广线为轴心城市和各省一二线城市)，以工业为载体、带动船舶漆、家装漆、内外墙涂料，使产品由华南地区知名品牌发展成为全国性的著名品牌。
      </div> -->
      <div class="xswd_title">珠江涂料官方授权零售店</div>
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column type="index" label="序号" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="name"
          label="门店名称"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="province" label="省份" align="center">
        </el-table-column>
        <el-table-column prop="city" label="城市" align="center">
        </el-table-column>
        <el-table-column prop="county" label="区县" align="center">
        </el-table-column>
        <el-table-column prop="township" label="乡镇/街道" align="center">
        </el-table-column>
        <el-table-column
          prop="address"
          label="详细地址"
          width="180"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="code" label="授权代码" align="center">
        </el-table-column>
        <div class="xswd_tips" slot="append">门店收录，持续更新中...</div>
      </el-table>
      <!-- <div class="xswd_img">
                <img src="../../../assets/enterzt04/map.png">
            </div> -->
    </div>
  </div>
</template>
<script>
import enterTit from '@/components/enterTit/index'
export default {
  components: { enterTit },
  data() {
    return {
      tableData: [
        {
          name: '华顺装饰材料店',
          province: '广东',
          city: '茂名',
          county: '高州市',
          township: '-',
          address: '高州市高凉中路130号',
          code: '珠涂·粤K168001',
        },
        {
          name: '友达化工贸易有限公司',
          province: '广东',
          city: '佛山',
          county: '顺德区',
          township: '陈村镇',
          address: '佛山市顺德区陈村镇锦龙村心福利楼8-10号',
          code: '珠涂·粤E168001',
        },
        {
          name: '全亮装饰材科店',
          province: '广东',
          city: '佛山',
          county: '顺德区',
          township: '大良街道',
          address: '佛山市顺德区大良街道东康路昌盛楼 61 号',
          code: '珠涂・粤 E168004',
        },
        {
          name: '港南涂料店',
          province: '广东',
          city: '佛山',
          county: '三水区',
          township: '西南街道',
          address: '佛山市三水区西南街健力宝北路 24 号 105-107 铺',
          code: '珠涂・粤 E168005',
        },
        {
          name: '穗庆建筑装饰材料店',
          province: '广东',
          city: '佛山',
          county: '三水区',
          township: '西南街道',
          address: '佛山市三水区广海大道 80 号',
          code: '珠涂・粤 E168006',
        },

        {
          name: '烨沣美建材商店',
          province: '广东',
          city: '佛山',
          county: '南海区',
          township: '丹灶镇',
          address: '佛山市南海区丹灶镇金沙城区安典加油站以东 100 米',
          code: '珠涂・粤 E168007',
        },
        {
          name: '国辉涂料商行',
          province: '福建',
          city: '泉州',
          county: '鲤城区',
          township: '江南街道',
          address: '福建省泉州市鲤城区锦美美兴路 130 号',
          code: '珠涂・闽 C168001',
        },
        {
          name: '龙江涂料商行',
          province: '福建',
          city: '泉州',
          county: '石狮市',
          township: '湖滨街道',
          address: '福建省泉州市石狮市湖滨街道宝岛中路 119-121 号',
          code: '珠涂・闽 C168002',
        },
        {
          name: '漆宝涂料商行',
          province: '福建',
          city: '泉州',
          county: '晋江市',
          township: '池店镇',
          address: '晋江市池店镇霞福村中骏四季花城 1 幢 121 号',
          code: '珠涂・闽 C168004',
        },
        {
          name: '文华涂料有限公司',
          province: '福建',
          city: '泉州',
          county: '鲤城区',
          township: '浮桥街道',
          address: '福建省泉州市鲤城区浮桥街 378 号',
          code: '珠涂・闽 C168005',
        },
      ],
    }
  },
}
</script>
<style lang="scss">
.xswd {
  width: 1200px;
  // height: 941px;
  background-color: #fdfeff;
  box-shadow: 0vw 0.1563vw 0.3646vw 0vw rgba(3, 74, 59, 0.05);
  border: solid 0.0521vw #eeeeee;
  padding: 40px 50px;
  box-sizing: border-box;
  .xswd_p {
    width: 100%;
    font-size: 16px;
    line-height: 32px;
    letter-spacing: 0.2083vw;
    color: #333333;
    margin-bottom: 50px;
    text-indent: 40px;
    text-align: justify;
  }
  .xswd_title {
    font-size: 30px;
    font-weight: bold;
    line-height: 1.5;
    color: #000;
    padding-bottom: 30px;
  }
  .xswd_tips {
    font-size: 16px;
    line-height: 1.5;
    color: #000;
    padding: 20px 10px;
  }
  img {
    width: 956px;
  }
}
</style>
